import { render, staticRenderFns } from "./customer-name.vue?vue&type=template&id=114ba418&scoped=true&"
import script from "./customer-name.vue?vue&type=script&lang=js&"
export * from "./customer-name.vue?vue&type=script&lang=js&"
import style0 from "./customer-name.vue?vue&type=style&index=0&id=114ba418&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114ba418",
  null
  
)

export default component.exports